<template>
	<div>
		<div class="text_box">
			<el-popover class="popover-text" placement="top-start" trigger="hover" :content="subText">
				<div slot="reference">{{ text || '-' }}</div>
			</el-popover>
			<ig-icon name="bianji" class="bianji-icon" @click="change"></ig-icon>
		</div>
		<el-dialog
			title="语言修改"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="400px"
			:before-close="resetFields"
		>
			<el-row :gutter="15">
				<el-col :span="4"><div class="textLabel">语言:</div> </el-col>
				<el-col :span="20"
					><el-select
						v-model="languagesList"
						multiple
						placeholder="请选择"
						style="width: 100%"
						clearable
					>
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item[propVal.label]"
							:value="item[propVal.value]"
							:props="propVal"
						>
						</el-option> </el-select
				></el-col>
			</el-row>

			<div class="btn-box">
				<el-button @click="resetFields">取消</el-button>
				<el-button type="primary" @click="updata">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import adsNewOnlineSer from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
export default {
	props: {
		tableData: Object,
		scope: Object,
		typeVal: null,
	},
	data() {
		return {
			dialogVisible: false,
			options: [],
			propVal: {
				label: 'languageNameZh',
				value: 'criterionId',
			},
			languagesList: [],
		};
	},

	components: {},
	watch: {
		'scope.row': {
			handler() {
				let arr = [];
				if (this.scope.row[this.tableData.bind]) {
					arr = this.scope.row[this.tableData.bind].map(e => {
						return e.criterionId;
					});
				}

				this.languagesList = arr;
			},
			deep: true,
			immediate: true,
		},
	},
	computed: {
		text() {
			let str = '';
			if (this.scope.row[this.tableData.bind]) {
				let arr = this.scope.row[this.tableData.bind].map(e => {
					return e.languageNameZh;
				});
				str = arr.length > 1 ? arr[0] + `等${arr.length}种` : arr[0];
			}
			return str;
		},
		subText() {
			let str = '';
			if (this.scope.row[this.tableData.bind]) {
				let arr = this.scope.row[this.tableData.bind].map(e => {
					return e.languageNameZh;
				});
				str = arr.join(',');
			}
			return str;
		},
	},

	methods: {
		async adLanguages() {
			let res = await adsNewOnlineSer.adLanguages();
			this.options = res.data;
		},
		async updata() {
			let res = await adsNewOnlineSer.update_ads(
				{
					id: this.scope.row.id,
					languagesList: this.languagesList,
					state: this.tableData.state, //0,核心推广产品;1,国家/地区
					isEmptyLanguages: this.languagesList.length ? 0 : 1,
				},
				{ type: this.typeVal } ///0,广告系列;1,广告组
			);
			if (res.data) {
				this.dialogVisible = false;
				this.$message({
					message: '修改成功',
					type: 'success',
				});
				let { scope, tableData } = this;
				tableData.change();
			} else {
				this.$message.error({
					message: '修改失败',
				});
			}
		},
		change() {
			this.dialogVisible = true;
		},
		resetFields() {
			this.dialogVisible = false;
			this.tableData.change();
		},
	},
	mounted() {
		this.adLanguages();
	},
};
</script>

<style lang="scss" scoped>
.text_box {
	display: flex;

	.bianji-icon {
		margin-left: 10px;
		cursor: pointer;
	}
}
.btn-box {
	margin-top: 40px;
	text-align: right;
}
.textLabel {
	line-height: 40px;
	text-align: right;
}
</style>
